import { isEmpty } from "lodash-es";
import { parseBool } from "./lodash-extensions";

export default class LocalStorageHelpers {
    static getBool(key, defaultValue=false) {
        return isEmpty(key) ? defaultValue : parseBool(localStorage.getItem(key), defaultValue);
    }
    static setBool(key, value) {
        if(isEmpty(key)) return;
        localStorage.setItem(key, parseBool(value));
    }
}